(function () {
	'use strict';

	// Boot package related to Spring-Boot specific use.

	angular
			.module('Core')
			.service('InfoService', InfoService);

	InfoService.$inject = ['$rootScope', '$q', '$http'];

	/*
	 * Application info services /info
	 */
	function InfoService($rootScope, $q, $http) {
		var _info;
		var service = {
			load: load,
			getVersion: getVersion,
			getTechnicalVersion: getTechnicalVersion,
			getTypeVersion: getTypeVersion,
			getEnv: getEnv
		};
		return service;

		function load() {
			var deferred = $q.defer();
			$http({
				method: 'get',
				url: 'info'
			}).success(function (data) {
				_info = data;
				$rootScope.info = data;
				deferred.resolve(data);
			}).error(function (data) {
				deferred.reject(data);
			});
			return deferred.promise;
		}

		function getVersion() {
			return _info.build.version;
		}

		function getTechnicalVersion() {
			return _info.build.version;
		}

		function getTypeVersion() {
			return _info.build.buildProfile;
		}

		function getEnv() {
			return _info.app.env;
		}

	}

})();
